import { render, staticRenderFns } from "./Trucks.vue?vue&type=template&id=2a90306b&scoped=true"
import script from "./Trucks.vue?vue&type=script&lang=js"
export * from "./Trucks.vue?vue&type=script&lang=js"
import style0 from "./Trucks.vue?vue&type=style&index=0&id=2a90306b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90306b",
  null
  
)

export default component.exports